/**
 * Black Friday product page: the tab bar under the photo. Click (or arrow keys) shows one panel at a time.
 */
(function () {
  function setup(root) {
    if (root._bfTabs) return;
    root._bfTabs = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-bf-tab]"));
    function show(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
        var panel = root.querySelector('[data-bf-panel="' + t.dataset.bfTab + '"]');
        if (panel) panel.hidden = !on;
      });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener("click", function () { show(tab); });
      tab.addEventListener("keydown", function (e) {
        var next = e.key === "ArrowRight" ? tabs[(i + 1) % tabs.length] : e.key === "ArrowLeft" ? tabs[(i - 1 + tabs.length) % tabs.length] : null;
        if (next) { e.preventDefault(); next.focus(); show(next); }
      });
    });
    show(tabs[0]);
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll("[data-bf-tabs]"), setup); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll("[data-bf-tabs]"), setup);
  });
})();
